<h1 mat-dialog-title >{{data.text}}</h1>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="[true]" cdkFocusInitial >{{ 'Confirm' | translate }}</button>
  <button mat-button [mat-dialog-close]="[false]" cdkFocusInitial >{{ 'Cancel' | translate }}</button>
</div>
